export enum EntityState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
